jQuery(document).ready(function () {
    initImageSlider();
    initImageSliderFrontpage();
    initBurgerMenu();
});

function initBurgerMenu() {
    const button = jQuery('.burger-menu');
    const container = jQuery('.navigation-mobile');
    const body = jQuery('body');
    const alternativeClosingButton = jQuery('.navigation-mobile .menu a');

    function event() {
        button.toggleClass('active');
        container.toggleClass('active');
        if (container.hasClass('has-opacity')) {
            container.animate({opacity: 0});
            container.removeClass('has-opacity');
            body.removeClass('no-scroll');
        } else {
            container.animate({opacity: 1}, 100);
            container.addClass('has-opacity');
            body.addClass('no-scroll');
        }
    }

    button.on('click', function () {
        event();
    });

    alternativeClosingButton.on('click', function () {
        event();
    });
}

function initImageSlider() {

    let container = jQuery('.image-slider');

    if (container.length) {
        jQuery(container).slick({
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 300,
            adaptiveHeight: false,
            slidesToShow: 1,
        });
    }
}

function initImageSliderFrontpage() {

    let container = jQuery('.image-slider-frontpage');
    if (container.length) {
        jQuery(container).slick({
            arrows: false,
            dots: true,
            infinite: true,
            autoplay: true,
            speed: 300,
            adaptiveHeight: false,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ],
        });
    }
}